webpackJsonp([19596653304890],{

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChristianWenz = __webpack_require__(50);
	
	var _ChristianWenz2 = _interopRequireDefault(_ChristianWenz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChristianWenz = function ChristianWenz() {
	    return _react2.default.createElement(
	        'section',
	        { id: 'speaker', className: 'parallax-section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'team-wrapper' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Christian Wenz'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement('img', { src: _ChristianWenz2.default, className: 'img-responsive', alt: 'Christian Wenz' }),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'social-icon' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement('a', { href: 'https://www.linkedin.com/in/christianwenz/', target: '_blank', className: 'fa fa-linkedin wow fadeIn' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement('a', { href: 'https://twitter.com/chwenz', target: '_blank', className: 'fa fa-twitter wow fadeIn' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-5' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Christian Wenz is an author, consultant and trainer focussing on web technologies and web application security. ',
	                                    _react2.default.createElement('br', null),
	                                    'He wrote or co-wrote over 100 books, is a fixture at international developer conferences since 2001, and a Microsoft MVP for ASP.NET since 2004. ',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    'His day job includes conducting security audits, migrating old code bases, implementing complex web applications and helping companies choose the right mix of web technologies.'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Talk: The Ten Most Critical Web Application Security Risks: OWASP Top Ten'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Since 2003, the Open Web Application Security Project curates a list of the top ten secuity risks for web applications. ',
	                                _react2.default.createElement('br', null),
	                                'The 2017 list is the most current one, trying to mix both common and upcoming attacks, and to stay relevant in an ever-changing web world. Time to get an up-to-date refresh on how to create secure web applications, including attacks that did not make the list (but should be in there).'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ChristianWenz;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-christian-wenz-js-1ac9340a430fade273de.js